import React from "react";
import { FiFolder } from "react-icons/fi";
import "./index.css";

export function CadastroPageHeader({
  eyebrow = "Cadastro administrativo",
  title,
  description,
  icon: Icon = FiFolder,
  context = "Operação organizada",
  contextDetail = "Dados prontos para o próximo passo",
}) {
  return (
    <header className="cadastro-header">
      <div>
        <span className="cadastro-eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>

      <div className="cadastro-header-note" aria-label={context}>
        <span className="cadastro-header-note-icon">
          <Icon aria-hidden="true" />
        </span>
        <span>
          <strong>{context}</strong>
          <small>{contextDetail}</small>
        </span>
      </div>
    </header>
  );
}

export function CadastroPanelHeading({ eyebrow, title, description, icon: Icon = FiFolder }) {
  return (
    <div className="cadastro-panel-heading">
      <span className="cadastro-panel-icon">
        <Icon aria-hidden="true" />
      </span>
      <div>
        <span className="cadastro-panel-kicker">{eyebrow}</span>
        <h2>{title}</h2>
        {description ? <p>{description}</p> : null}
      </div>
    </div>
  );
}

export default CadastroPageHeader;
